(function () {
  'use strict';

  let currentProduct = null;
  let selectedVariantId = null;
  let selectedSize = null;
  let quantity = 1;

  let overlay, modal, closeBtn, nameEl, priceEl, imageEl,
      imageWrapEl, ratingEl, colorsWrap, colorsEl, sizesEl,
      addBtn, viewLink, sizeError, toast, toastTimer,
      qtyDown, qtyUp, qtyNum;

  var isProductPage = window.location.pathname.indexOf('/products/') > -1;
  var ratingCache = {};

  function injectTriggers() {
    if (isProductPage) return;
    const cardImages = document.querySelectorAll('.grid__wrapper .prod-image');
    cardImages.forEach(function (wrap) {
      if (wrap.querySelector('.dtl-qa-trigger')) return;
      const pos = window.getComputedStyle(wrap).position;
      if (pos === 'static') wrap.style.position = 'relative';
      const btn = document.createElement('button');
      btn.className = 'dtl-qa-trigger';
      btn.setAttribute('aria-label', 'Quick add to cart');
      btn.setAttribute('type', 'button');
      btn.innerHTML = `
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M4.5 5.5V3.75C4.5 2.23122 5.73122 1 7.25 1C8.76878 1 10 2.23122 10 3.75V5.5M2 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V6.5C14 6.10218 13.842 5.72064 13.5607 5.43934C13.2794 5.15804 12.8978 5 12.5 5H2C1.60218 5 1.22064 5.15804 0.93934 5.43934C0.658036 5.72064 0.5 6.10218 0.5 6.5V12.5C0.5 12.8978 0.658036 13.2794 0.93934 13.5607C1.22064 13.842 1.60196 14 2 14Z" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const productCard = wrap.closest('.featured__collection-product, .product-index');
        const selectedHandle = productCard?.dataset?.selectedHandle;
        if (selectedHandle) {
          fetchProductAndOpen(selectedHandle);
        } else {
          openQuickAdd(wrap);
        }
      });
      wrap.appendChild(btn);
    });
  }

  function openQuickAdd(imageWrap) {
    const card = imageWrap.closest('.ci, [data-product-id], .product-card, .card-wrapper, .product-item, .grid__item');
    if (!card) return;
    let productData = null;
    const jsonScript = card.querySelector('script[type="application/json"]');
    if (jsonScript) {
      try { productData = JSON.parse(jsonScript.textContent); } catch (err) {}
    }
    if (!productData && card.dataset.productJson) {
      try { productData = JSON.parse(card.dataset.productJson); } catch (err) {}
    }
    if (!productData) {
      const handle =
        card.dataset.productHandle ||
        card.querySelector('[data-product-handle]')?.dataset.productHandle ||
        card.querySelector('a[href*="/products/"]')?.href.split('/products/')[1]?.split('?')[0];
      if (handle) { fetchProductAndOpen(handle); return; }
    }
    if (!productData) return;
    populateModal(productData);
  }

  function fetchProductAndOpen(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { populateModal(data); })
      .catch(function (err) { console.error('[DTL Quick Add] Fetch failed:', err); });
  }

  function getSizeOptionIndex(product) {
    return product.options.findIndex(function (o) {
      const name = typeof o === 'string' ? o : o.name;
      const lower = name.toLowerCase();
      return lower === 'size' || lower.includes('bust') || lower.includes('under');
    });
  }

  function populateModal(product) {
    currentProduct = product;
    selectedVariantId = null;
    selectedSize = null;
    quantity = 1;
    qtyNum.textContent = '1';

    nameEl.textContent = product.title;
    const firstAvailable = product.variants.find(function (v) { return v.available; });
    const firstPrice = firstAvailable ? firstAvailable.price : product.variants[0].price;
    priceEl.textContent = formatMoney(firstPrice);
    viewLink.href = '/products/' + product.handle;

    const imgSrc = typeof product.featured_image === 'string'
      ? product.featured_image
      : (product.featured_image && product.featured_image.src ? product.featured_image.src : null);
    if (imgSrc) {
      imageEl.src = imgSrc;
      imageEl.alt = product.title;
      imageWrapEl.style.display = '';
    } else {
      imageWrapEl.style.display = 'none';
    }

    ratingEl.style.display = 'none';
    if (ratingCache[product.handle]) {
      ratingEl.innerHTML = ratingCache[product.handle];
      ratingEl.style.display = 'flex';
    } else {
      fetch('/products/' + product.handle)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var ratingTextEl = doc.querySelector('.product__section-rating-text span[aria-hidden]');
          var countEl = doc.querySelector('.product__section-rating-count span[aria-hidden]');
          if (ratingTextEl) {
            var ratingText = ratingTextEl.textContent.trim();
            var count = countEl ? countEl.textContent.trim() : '';
            var html = '<span class="dtl-qa-stars">★★★★★</span><span>' + ratingText + ' ' + count + '</span>';
            ratingCache[product.handle] = html;
            ratingEl.innerHTML = html;
            ratingEl.style.display = 'flex';
          }
        })
        .catch(function() {});
    }

    const colourOption = product.options.find(function (o) {
      const name = typeof o === 'string' ? o : o.name;
      return name.toLowerCase() === 'colour' || name.toLowerCase() === 'color';
    });
    const colourIndex = colourOption ? product.options.indexOf(colourOption) : -1;
    if (colourIndex > -1) {
      colorsWrap.style.display = '';
      const colourValues = [...new Set(product.variants.map(function (v) { return v.options[colourIndex]; }))];
      colorsEl.innerHTML = colourValues.map(function (colour, i) {
        const hex = colourHex(colour);
        return `<div
          class="dtl-qa-color-swatch${i === 0 ? ' is-active' : ''}"
          style="background: ${hex};"
          data-colour="${colour}"
          title="${colour}"
          role="radio"
          aria-label="${colour}"
          tabindex="0"
        ></div>`;
      }).join('');
      colorsEl.querySelectorAll('.dtl-qa-color-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          colorsEl.querySelectorAll('.dtl-qa-color-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          selectedVariantId = null;
          selectedSize = null;
          renderSizes(product, colourIndex, swatch.dataset.colour);
        });
      });
      renderSizes(product, colourIndex, colourValues[0]);
    } else {
      colorsWrap.style.display = 'none';
      renderSizes(product, -1, null);
    }

    resetAddBtn();
    sizeError.classList.remove('is-visible');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function renderSizes(product, colourIndex, selectedColour) {
    const sizeOptionIndex = getSizeOptionIndex(product);
    const cupOptionIndex = product.options.findIndex(function (o) {
      const name = typeof o === 'string' ? o : o.name;
      return name.toLowerCase().includes('cup');
    });

    const variantsToShow = colourIndex > -1
      ? product.variants.filter(function (v) { return v.options[colourIndex] === selectedColour; })
      : product.variants;

    const uniqueSizes = [];
    const seenSizes = {};
    variantsToShow.forEach(function(variant) {
      const label = sizeOptionIndex > -1 ? variant.options[sizeOptionIndex] : variant.title;
      if (!seenSizes[label]) {
        seenSizes[label] = true;
        uniqueSizes.push({ variant: variant, label: label });
      }
    });

    const uniqueCups = [];
    const seenCups = {};
    if (cupOptionIndex > -1) {
      variantsToShow.forEach(function(variant) {
        const label = variant.options[cupOptionIndex];
        if (!seenCups[label]) {
          seenCups[label] = true;
          uniqueCups.push({ variant: variant, label: label });
        }
      });
    }

    sizesEl.innerHTML = '<div class="dtl-qa-sizes-grid">' + uniqueSizes.map(function (item) {
      const soldOut = !item.variant.available;
      return `<button
        class="dtl-qa-size-btn${soldOut ? ' is-sold-out' : ''}"
        data-variant-id="${item.variant.id}"
        data-size="${item.label}"
        ${soldOut ? 'aria-disabled="true"' : ''}
        type="button"
      >${item.label}</button>`;
    }).join('') + '</div>';

    if (uniqueCups.length > 0) {
      sizesEl.innerHTML += `<p class="dtl-qa-label" style="margin-top: 10px;">Cup</p>`;
      sizesEl.innerHTML += `<div class="dtl-qa-cups">` +
        uniqueCups.map(function(item) {
          return `<button class="dtl-qa-size-btn dtl-qa-cup-btn" data-cup="${item.label}" type="button">${item.label}</button>`;
        }).join('') + `</div>`;
    }

    sizesEl.querySelectorAll('.dtl-qa-size-btn:not(.is-sold-out):not(.dtl-qa-cup-btn)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizesEl.querySelectorAll('.dtl-qa-size-btn:not(.dtl-qa-cup-btn)').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedVariantId = btn.dataset.variantId;
        selectedSize = btn.dataset.size;
        sizeError.classList.remove('is-visible');
        updateVariantFromSelections(product, colourIndex, selectedColour, sizeOptionIndex, cupOptionIndex);
      });
    });

    sizesEl.querySelectorAll('.dtl-qa-cup-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizesEl.querySelectorAll('.dtl-qa-cup-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateVariantFromSelections(product, colourIndex, selectedColour, sizeOptionIndex, cupOptionIndex);
      });
    });
  }

  function updateVariantFromSelections(product, colourIndex, selectedColour, sizeOptionIndex, cupOptionIndex) {
    const selectedSizeBtn = sizesEl.querySelector('.dtl-qa-size-btn:not(.dtl-qa-cup-btn).is-active');
    const selectedCupBtn = sizesEl.querySelector('.dtl-qa-cup-btn.is-active');
    if (!selectedSizeBtn) return;
    const selectedSizeVal = selectedSizeBtn.dataset.size;
    const selectedCupVal = selectedCupBtn ? selectedCupBtn.dataset.cup : null;
    const matchingVariant = product.variants.find(function(v) {
      const sizeMatch = sizeOptionIndex > -1 ? v.options[sizeOptionIndex] === selectedSizeVal : v.title === selectedSizeVal;
      const colourMatch = colourIndex > -1 ? v.options[colourIndex] === selectedColour : true;
      const cupMatch = cupOptionIndex > -1 && selectedCupVal ? v.options[cupOptionIndex] === selectedCupVal : true;
      return sizeMatch && colourMatch && cupMatch;
    });
    if (matchingVariant) {
      selectedVariantId = matchingVariant.id;
      selectedSize = selectedSizeVal + (selectedCupVal ? ' / ' + selectedCupVal : '');
    }
  }

  function handleAddToCart() {
    if (!selectedVariantId) {
      sizeError.classList.add('is-visible');
      sizesEl.querySelectorAll('.dtl-qa-size-btn:not(.is-sold-out):not(.dtl-qa-cup-btn)').forEach(function (b) {
        b.style.borderColor = '#c0392b';
        setTimeout(function () { b.style.borderColor = ''; }, 800);
      });
      return;
    }
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        addBtn.textContent = '✓  Added to Bag';
        addBtn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEls = document.querySelectorAll('.cart-count, .cart__count, [data-cart-count], .js-cart-count, .cart-item-count, #cart-count, .cart__item-count, [data-cart-item-count]');
            countEls.forEach(function(el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (window.HS_SLIDE_CART_UPDATE) window.HS_SLIDE_CART_UPDATE();
          });
        setTimeout(function () {
          closeModal();
          showToast(currentProduct.title + ' (' + selectedSize + ') added to bag');
        }, 700);
      })
      .catch(function (err) {
        console.error('[DTL Quick Add] Cart add error:', err);
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
      });
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(resetAddBtn, 350);
  }

  function resetAddBtn() {
    if (!addBtn) return;
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Bag';
    addBtn.classList.remove('is-added');
  }

  function showToast(message) {
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var COLOUR_MAP = {
    'black': '#1A1A1A',
    'vanilla white': '#F1ECE3',
    'mauve pink': '#D89CA0',
    'dusty pink': '#CBA3A0',
    'espresso': '#4A392E',
    'magenta': '#7D1F35',
    'purple': '#35205A',
    'royal blue': '#1B3350',
    'sky blue': '#3E6FE0',
    'teal': '#1D5266',
    'forest green': '#37453F',
    'ruby red': '#7A1F30',
    'navy': '#141C33',
    'pale blue': '#C7D8E8',
    'grey marl': '#D4D4D6'
  };

  function colourHex(name) {
    if (!name) return '#cccccc';
    const lower = name.toLowerCase();
    if (COLOUR_MAP[lower]) return COLOUR_MAP[lower];
    const lastWord = lower.split(' ').pop();
    if (COLOUR_MAP[lastWord]) return COLOUR_MAP[lastWord];
    return name;
  }

  function init() {
    overlay     = document.getElementById('dtl-quick-add-overlay');
    modal       = document.getElementById('dtl-qa-modal');
    closeBtn    = document.getElementById('dtl-qa-close');
    nameEl      = document.getElementById('dtl-qa-product-name');
    priceEl     = document.getElementById('dtl-qa-product-price');
    imageEl     = document.getElementById('dtl-qa-image');
    imageWrapEl = document.getElementById('dtl-qa-image-wrap');
    ratingEl    = document.getElementById('dtl-qa-rating');
    colorsWrap  = document.getElementById('dtl-qa-colors-wrap');
    colorsEl    = document.getElementById('dtl-qa-colors');
    sizesEl     = document.getElementById('dtl-qa-sizes');
    addBtn      = document.getElementById('dtl-qa-add-btn');
    viewLink    = document.getElementById('dtl-qa-view-link');
    sizeError   = document.getElementById('dtl-qa-size-error');
    toast       = document.getElementById('dtl-qa-toast');
    qtyDown     = document.getElementById('dtl-qa-qty-down');
    qtyUp       = document.getElementById('dtl-qa-qty-up');
    qtyNum      = document.getElementById('dtl-qa-qty-num');

    if (!overlay) {
      console.warn('[DTL Quick Add] Modal HTML not found.');
      return;
    }

    closeBtn.addEventListener('click', closeModal);
    addBtn.addEventListener('click', handleAddToCart);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    qtyDown.addEventListener('click', function () {
      if (quantity > 1) {
        quantity--;
        qtyNum.textContent = quantity;
      }
    });

    qtyUp.addEventListener('click', function () {
      quantity++;
      qtyNum.textContent = quantity;
    });

    injectTriggers();
    setTimeout(injectTriggers, 1000);
    setTimeout(injectTriggers, 3000);
    setTimeout(injectTriggers, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Pre-fetch ratings */
  function prefetchRatings() {
    if (isProductPage) return;
    document.querySelectorAll('[data-product-handle]').forEach(function(card) {
      var handle = card.dataset.productHandle;
      if (handle && !ratingCache[handle]) {
        ratingCache[handle] = 'loading';
        fetch('/products/' + handle)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var ratingTextEl = doc.querySelector('.product__section-rating-text span[aria-hidden]');
            var countEl = doc.querySelector('.product__section-rating-count span[aria-hidden]');
            if (ratingTextEl) {
              var ratingText = ratingTextEl.textContent.trim();
              var count = countEl ? countEl.textContent.trim() : '';
              ratingCache[handle] = '<span class="dtl-qa-stars">★★★★★</span><span>' + ratingText + ' ' + count + '</span>';
            } else {
              ratingCache[handle] = null;
            }
          })
          .catch(function() { ratingCache[handle] = null; });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefetchRatings);
  } else {
    prefetchRatings();
  }

  /* PLP colour swatches */
  const PLP_COLOR_MAP = {
    'black': '#1A1A1A',
    'vanilla white': '#F1ECE3',
    'mauve pink': '#D89CA0',
    'dusty pink': '#CBA3A0',
    'espresso': '#4A392E',
    'magenta': '#7D1F35',
    'purple': '#35205A',
    'royal blue': '#1B3350',
    'sky blue': '#3E6FE0',
    'teal': '#1D5266',
    'forest green': '#37453F',
    'ruby red': '#7A1F30',
    'navy': '#141C33',
    'pale blue': '#C7D8E8',
    'grey marl': '#D4D4D6'
  };

  /* TEMPORARY FALLBACK — remove once Shopify's Storefront API search
     index picks up these products (title search currently returns
     empty results for this title, despite products being Active and
     published to the same channels as other working products). */
  const HARDCODED_SWATCHES = {
    'Oversized Bamboo Cotton Tee': [
      { handle: 'oversized-bamboo-cotton-tee-mauve-pink', color: 'Mauve Pink', imageUrl: 'https://cdn.shopify.com/s/files/1/0047/9638/3330/files/espressoHIB-54.jpg?v=1784430448' },
      { handle: 'oversized-bamboo-cotton-tee-white', color: 'Vanilla White', imageUrl: 'https://cdn.shopify.com/s/files/1/0047/9638/3330/files/espressoHIB-35.jpg?v=1784263359' },
      { handle: 'oversized-bamboo-cotton-tee-black', color: 'Black', imageUrl: 'https://cdn.shopify.com/s/files/1/0047/9638/3330/files/7_8-30.jpg?v=1784439834' }
    ]
  };

  function getHexForColor(color) {
    const lower = color.toLowerCase();
    if (PLP_COLOR_MAP[lower]) return PLP_COLOR_MAP[lower];
    const lastWord = lower.split(' ').pop();
    return PLP_COLOR_MAP[lastWord] || lastWord;
  }

  async function loadPLPSwatches() {
    const containers = document.querySelectorAll('.plp-color-swatches');
    if (!containers.length) return;

    const titleMap = {};
    containers.forEach(function(el) {
      const title = el.dataset.productTitle;
      if (!titleMap[title]) titleMap[title] = [];
      titleMap[title].push(el);
    });

    await Promise.all(Object.keys(titleMap).map(async function(title) {
      try {
        let products;

        if (HARDCODED_SWATCHES[title]) {
          products = HARDCODED_SWATCHES[title].map(function(s) {
            return {
              handle: s.handle,
              title: title,
              options: [{ name: 'Size', values: [] }, { name: 'Color', values: [s.color] }],
              featuredImage: { url: s.imageUrl }
            };
          });
        } else {
          const cacheKey = 'dtl_swatches_' + title;
          const cached = sessionStorage.getItem(cacheKey);
          if (cached) {
            products = JSON.parse(cached);
          } else {
            const query = `{
              products(first: 250, query: "title:'${title}'") {
                edges {
                  node {
                    handle
                    title
                    options { name values }
                    featuredImage { url }
                  }
                }
              }
            }`;
            const res = await fetch('/api/2024-01/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': 'd23396d9f8aedceefadd02de26387222'
              },
              body: JSON.stringify({ query })
            });
            const data = await res.json();
            products = data.data.products.edges.map(function(e) { return e.node; });
            sessionStorage.setItem(cacheKey, JSON.stringify(products));
          }
        }

        titleMap[title].forEach(function(container) {
          const currentHandle = container.dataset.productHandle;
          const swatches = [];

          const currentP = products.find(function(p) { return p.handle === currentHandle; });
          if (currentP) {
            const colorOption = currentP.options.find(function(o) {
              const n = o.name.toLowerCase();
              return n === 'color' || n === 'colour';
            });
            const color = colorOption ? colorOption.values[0] : (currentP.options[1]?.values[0] || currentP.options[0]?.values[0] || '');
            const hexColor = getHexForColor(color);
            const imageUrl = currentP.featuredImage?.url || '';
            swatches.push({ handle: currentHandle, color, hexColor, isCurrent: true, imageUrl });
          }

          products.forEach(function(p) {
            if (p.handle === currentHandle) return;
            if (p.title !== title) return;
            const colorOption = p.options.find(function(o) {
              const n = o.name.toLowerCase();
              return n === 'color' || n === 'colour';
            });
            const color = colorOption ? colorOption.values[0] : (p.options[1]?.values[0] || p.options[0]?.values[0] || '');
            const hexColor = getHexForColor(color);
            const imageUrl = p.featuredImage?.url || '';
            swatches.push({ handle: p.handle, color, hexColor, isCurrent: false, imageUrl });
          });

          const isMobile = window.innerWidth <= 768;
          const size = isMobile ? '14px' : '16px';

          let html = swatches.map(function(s) {
            const ring = s.isCurrent ? 'box-shadow:0 0 0 2px #ffffff, 0 0 0 3px #111111;' : '';
            return `<span style="display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;padding:3px;"><span title="${s.color}" data-handle="${s.handle}" data-image="${s.imageUrl}" data-current="${s.isCurrent}" class="plp-swatch-link" style="display:inline-block;width:${size};height:${size};border-radius:50%;background-color:${s.hexColor};border:1px solid rgba(0,0,0,0.15);cursor:pointer;${ring}"></span></span>`;
          }).join('');

          container.innerHTML = html;

          const wrap = container.parentElement;
          container.addEventListener('scroll', function() {
            const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 2;
            if (wrap) wrap.style.setProperty('--chevron-opacity', atEnd ? '0' : '1');
          });
        });
      } catch(e) {
        console.error('[DTL PLP Swatches]', e);
      }
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPLPSwatches);
  } else {
    loadPLPSwatches();
  }

  // Swatch click handler
  document.addEventListener('mousedown', function(e) {
    const link = e.target.closest('.plp-swatch-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();

    const handle = link.dataset.handle;
    const imageUrl = link.dataset.image;
    const container = link.closest('.plp-color-swatches');
    const productCard = container?.parentElement?.parentElement;
    if (!productCard) return;

    // Store selected handle for quick add modal
    link.closest('.plp-color-swatches-wrap')?.parentElement?.setAttribute('data-selected-handle', handle);

    // Update active ring
    container.querySelectorAll('.plp-swatch-link').forEach(function(l) {
      l.style.boxShadow = '';
      l.style.border = '1px solid rgba(0,0,0,0.15)';
    });
    link.style.boxShadow = '0 0 0 2px #ffffff, 0 0 0 3px #111111';

    // Update main image immediately
    const imgEl = productCard.querySelector('.reveal > img, .reveal div:not(.hidden) img');
    if (imgEl && imageUrl) {
      imgEl.src = imageUrl;
      imgEl.srcset = '';
      imgEl.sizes = '';
    }

    // Set hover image to main image immediately to prevent flash
    const hoverImg = productCard.querySelector('.hidden img');
    if (hoverImg) {
      hoverImg.src = imageUrl;
      hoverImg.srcset = '';
      hoverImg.sizes = '';
    }

    // Then fetch correct second image
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (hoverImg) {
          const secondMedia = data.media && data.media[1];
          const hoverUrl = secondMedia ? secondMedia.src : imageUrl;
          hoverImg.src = hoverUrl;
          hoverImg.srcset = '';
          hoverImg.sizes = '';
        }
      })
      .catch(function() {});

    // Update all product links to new colour
    productCard.querySelectorAll('a:not(.plp-swatch-link):not(.plp-swatch-more)').forEach(function(a) {
      if (a.href.includes('/products/')) {
        a.href = '/products/' + handle;
      }
    });
  }, true);

})();